module.exports = __webpack_public_path__ + "img/图标背景.03b8ec9c.svg";